import type { Breakpoint } from "@mui/material/styles";
import type { SxProps, Theme } from "@mui/material/styles";

/** Shared max width for public marketing pages (MUI `lg` = 1200px). */
export const PUBLIC_PAGE_CONTAINER_MAX_WIDTH: Breakpoint = "lg";

/** Consistent horizontal padding for public page containers. */
export const publicPageContainerSx: SxProps<Theme> = {
  px: { xs: 2, md: 4 },
  width: "100%",
  boxSizing: "border-box",
};
